import { render, staticRenderFns } from "./TemplateSubmissionDetailInfo.vue?vue&type=template&id=5f882379&scoped=true&"
import script from "./TemplateSubmissionDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./TemplateSubmissionDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSubmissionDetailInfo.vue?vue&type=style&index=0&id=5f882379&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f882379",
  null
  
)

export default component.exports